import { render, staticRenderFns } from "./infoGrupo.vue?vue&type=template&id=c3db0dc2&scoped=true"
import script from "./infoGrupo.vue?vue&type=script&lang=js"
export * from "./infoGrupo.vue?vue&type=script&lang=js"
import style0 from "./infoGrupo.vue?vue&type=style&index=0&id=c3db0dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db0dc2",
  null
  
)

export default component.exports